<template>
  <b-modal
    ref="cancellation-conditions-modal-ref"
    hide-footer
    hide-header
  >
    <div class="vtd-modal-content">
      <div class="vtd-modal-header">
        <h5
          v-if="userData"
          class="vtd-modal-title"
        >
          {{ stage === 0 ? 'Cancellation Conditions for booking' : 'Cancel Notification for ' }}
          <strong style="text-transform: uppercase">{{
            userData.bookno
          }}</strong>
        </h5>
        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="closeModal"
        >
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>
      <div class="vtd-modal-body">
        <div
          v-if="content"
          class="container_12"
        >
          <div
            v-if="stage === 0"
            id="navContent"
            class="row-fluid"
          >
            <div v-html="content" />

            <div
              class="row-fluid"
            >
              <button
                v-if="isInternal"
                :disabled="disableCancellationInt"
                class="btn btn-danger m-auto rounded"
                @click.prevent="
                  () => {
                    onSubmitInternalCancellation();
                  }
                "
              >
                Print Cancellation Form
              </button>
              <button
                v-else-if="showCancellationButton === true"
                class="btn btn-danger m-auto rounded"
                @click.prevent="
                  () => {
                    displayCancelStages();
                  }
                "
              >
                Proceed To Cancel My Trip
              </button>
              <div
                v-else-if="accountInfo.cancellationavailable === 'NO'"
                v-html="accountInfo.cancellationtext"
              /> 
            </div>
          </div>

          <div class="row-fluid">
            <Step1
              v-if="stage === 1"
              :account-info="accountInfo"
              :currency="currency"
              :canx-val="canxVal"
              @setPassenger="(pas) => passenger = pas"
              @setTerms="(bool) => terms = bool"
              @nextStage="(i) => stage = i"
            />
            <Step2
              v-if="stage === 2"
              :account-info="accountInfo"
              :currency="currency"
              :canx-val="canxVal"
              @setAllBooking="(bool) => allBooking = bool"
              @nextStage="(i) => stage = i"
            />
            <Step3
              v-if="stage === 3 || stage === 5 || stage === 6"
              :account-info="{accountInfo}"
              :currency="currency"
              :canx-val="canxVal"
              :stage="stage"
              :passenger="passenger"
              :pax-names="booking.user_information.names_plus"
              @setAllBooking="(bool) => allBooking = bool"
              @setCancelledTravellers="(arr) => cancelledTravellers = arr"
              @setPotentialTravellers="(arr) => potentialTravellers = arr"
              @nextStage="(i) => stage = i"
            />
            <Step4
              v-if="stage === 4"
              :account-info="{accountInfo}"
              :currency="currency"
              :canx-val="canxVal"
              @nextStage="(i) => stage = i"
            />
            <Step7
              v-if="stage === 7"
              :cancellation-names="cancelledTravellers"
              :potential-names="potentialTravellers"
              :submit-error="submitError"
              :disable-cancellation="disableCancellation"
              :passenger="passenger"
              @submitCancellation="onSubmitCancellation($event)"
            />
            <Step8
              v-if="stage === 8"
            />
          </div>
        </div>
        <ServiceErrorMessage :error-loading-data="errorLoadingData" />
      </div>
      <div class="btn-wrap mt-4">
        <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
          <small>This information was generated at:
            <strong class="return-date">{{ returnDate }}</strong></small>
        </div>
      </div>
    </div>
    <LoginToken ref="LoginTokenRef" />
  </b-modal>
</template>

<script>
import dayjs from '@/lib/dayjs';
const parser = new DOMParser()
import LoginToken from "@/modules/auth/login-token";
import ServiceErrorMessage from "@/partials/service-error-message";
import { getCancellationConditions, sendSMS, checkSMS, submitCancellation, submitIntCancellation } from "./services";
import Step1 from "./step1.vue";
import Step2 from "./step2.vue";
import Step3 from "./step3.vue";
import Step4 from "./step4.vue";
import Step7 from "./step7.vue";
import Step8 from "./step8.vue";
import { mapGetters, mapState } from "vuex";
const { VUE_APP_VT_API_URL, NODE_ENV } =
  process.env
export default {
  components: {
    LoginToken,
    ServiceErrorMessage,
    Step1,
    Step2,
    Step3,
    Step4,
    Step7,
    Step8
  },
  data() {
    return {
      content: "",
      smsError: false,
      submitError: false,
      canxError: false,
      cancelledTravellers: [],
      terms: false,
      allBooking: false,
      potentialTravellers: [],
      disableCancellation:false,
      disableCancellationInt: false,
      canxSuccess: false,
      showCancellationButton: false,
      errorLoadingData: false,
      extText: "Please note this excludes any insurance or amendment fees.",
      intText: "Please note the cancellation conditions stated above are for the booking as a whole and on the basis that all clients are cancelling.",
      stage: 0,
      hasProceedBtn: null,
      passenger: {},
    };
  },
  computed: {
    ...mapState("auth", ["token"]),
    ...mapGetters({
      userData: "auth/getUserData",
      bookingContacts: "booking/getBookingContacts",
      bookingNumber: "booking/getBookingNumber",
      bookingName: "booking/getBookingSurname",
      accountInfo: "booking/getAccount",
      departureDate: "booking/getDeptDate",
      bookingData: 'booking/getBooking',
      isAuthorisedWithToken: "auth/isAuthorisedWithToken",
      paxNames: "booking/getBookingPassengers",
      booking: "booking/getBooking",
      isInternal: "getInternal"
    }),
    // Used for the footer
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
    canxDate() {
      return dayjs().format("ddd DD MMM YYYY");
    },
    refundDate() {
      return dayjs().add(12, 'weeks').format("ddd DD MMM YYYY");
    },
    currency() {
      return this.userData.bookno.charAt(0).toUpperCase() === 'R' ? '€' : '£'
    },
    canxVal() {
      let _tmp = Math.round(this.accountInfo.cancellationvalue * 100) / 100
      return _tmp.toFixed(2);
    },
  },
  methods: { 
    allPaxNames() {
           if (this.paxNames && this.paxNames.length) {
             let mapOptions =  this.paxNames.map((pax) => { return pax.name })
              return mapOptions
           } else {
             return [ 'No Passengers Found' ]
           }
      },
    
    calcRemainingTravellers() {
      let tmpRemainingTravellers = []
      this.booking.user_information.names_plus.forEach((pax) => {
        if (!this.cancelledTravellers.includes(pax.name) && !this.potentialTravellers.includes(pax.name)) {
          tmpRemainingTravellers.push(pax.name)
        } 
        return

      })
      return tmpRemainingTravellers
    },
    async onSubmitCancellation(email) {
      this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
      this.disableCancellation = true
      this.submitError = false
      const data = {
        allBooking: this.allBooking,
        terms: this.terms,
        cancelledTravellers: this.cancelledTravellers,
        potentialTravellers: this.potentialTravellers,
        remainingTravellers:  await this.calcRemainingTravellers(),
        notificationText: this.accountInfo.cancellationtext,
        passenger: this.passenger ? this.passenger : 'No 2FA',
        created_date: new Date(),
        extText: this.extText,
        intText: "n/a",
        updated_date: new Date(),
        vtCancellationAvail: this.booking.account_information.cancellationavailable,
        updated_by: 'n/a',
        status: 'New',
        deptDate: this.departureDate,
        site: window.location.host,
        bookingNumber: this.bookingNumber,
        fileName: `TF-VT-Cancellation-${this.bookingNumber.toUpperCase()}-${Math.random()
          .toString(36)
          .slice(-6)
          .toUpperCase()}`,
        _doc: 'empty',
        type: 'ext'
      }
      if (data.allBooking) {
        data.cancelledTravellers = await this.allPaxNames()
        data.remainingTravellers = []
        data.potentialTravellers = []
      }
      if (this.passenger.email !== email) {
        data.newEmail = email
      }
      let res = await submitCancellation(data, this.token)
      if (res && res.error === false) {
        this.$store.dispatch("spinner/updateLoadingAction", false, { root: true });
        this.stage = 8
      } else {
        this.$store.dispatch("spinner/updateLoadingAction", false, { root: true });
        this.disableCancellation = false
        this.submitError = true
      }
    },
    async onSubmitInternalCancellation() {
      this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
      this.disableCancellationInt = true
      this.submitError = false
      const data = {
        allBooking: null,
        terms: null,
        cancelledTravellers: [],
        potentialTravellers: [],
        remainingTravellers:  await this.calcRemainingTravellers(),
        notificationText: this.accountInfo.cancellationtext,
        passenger: 'Internal',
        created_date: new Date(),
        updated_date: new Date(),
        updated_by: 'n/a',
        deptDate: this.departureDate,
        status: 'New',
        extText: 'n/a',
        vtCancellationAvail: this.booking.account_information.cancellationavailable,
        intText: this.intText,
        site: window.location.host,
        bookingNumber: this.bookingNumber,
        fileName: `TF-VT-Cancellation-${this.bookingNumber.toUpperCase()}-${Math.random()
          .toString(36)
          .slice(-6)
          .toUpperCase()}`,
        _doc: 'empty',
        type: 'int'
      }
      let res = await submitIntCancellation(data, this.token)
      if (res && res.data) {
        const a = document.createElement("a");
        let fileURL = `${VUE_APP_VT_API_URL}/vt-api/viewtrail/cancellation/pdf/int/${res.data._id.toString()}`
        a.href = fileURL;
        a.setAttribute("download", data.fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(fileURL);
        this.$store.dispatch("spinner/updateLoadingAction", false, {
          root: true,
        });

      } else {
        this.$store.dispatch("spinner/updateLoadingAction", false, { root: true });

        this.disableCancellationInt = false
        this.submitError = true
      }
    },
    async sendSMS() {
      const bookingInfo = {
        clientname: this.bookingName,
        custno: this.userData.custno,
        bookno: this.bookingNumber,
        email: this.bookingData.user_information.email,
        staffbkg: false,
        system: this.userData.system,
        tf_phone: this.bookingContacts[0].line0.telno
      }
      let res = await sendSMS(bookingInfo);
      if (res === 'ok') {
        this.stage = 4;
      } else {
        this.smsError = true;
      }
    },
    async showModal(panelObj) {
      panelObj = panelObj || 0 // optional arg
      if(panelObj.hasProceedBtn) {
        this.hasProceedBtn = true
        document.querySelector("#close-make-payment-modal").click() 
      } 
      this.$refs["cancellation-conditions-modal-ref"].show();
      // If we have content then we can just show that
      if (this.content !== "") {
        return;
      }
      // Show loading spinner on top of the modal
      this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
      // Get content from service
      let result = await getCancellationConditions(
        this.bookingNumber,
        this.bookingName
      );
      if (result.error === true) {
        this.errorLoadingData = true;
      }
      if (result.data) {
        this.content = result.data;
      }
      // Can we display the cancellation button? Changed to If Booking is Main File
      // if (this.accountInfo.cancellationavailable !== "NO") {
        if (this.accountInfo.fil === "M" && this.accountInfo.cancellationavailable.toUpperCase() === 'YES') {
        this.showCancellationButton = true;
      }
      // stop spinner
      this.$store.dispatch("spinner/updateLoadingAction", false, {
        root: true
      });
    },
    displayCancelStages() {
      this.stage = 1;
    },
    closeModal() {
      this.stage = 0
      this.submitError = false
      this.$refs["cancellation-conditions-modal-ref"].hide();
    }
  }
};
</script>
<style lang="scss">
  @import "./style.scss";
</style>
